// extracted by mini-css-extract-plugin
module.exports = {"imagemCabecalho":"ConteudoEmail_imagemCabecalho__2MqI5","imagem":"ConteudoEmail_imagem__2RkpQ"};